import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(100, 109, 130, 0.14), 0 0 1px 0 rgba(100, 109, 130, 0.1);
`;

export const ChartContainer = styled.div`
  align-items: center;
  display: flex;
  height: calc(100% - 68px);
  justify-content: center;
  padding: 24px;
  width: 100%;
`;

export const Title = styled.h1`
  color: #4a4a4a;
  font-size: 16px;
  font-weight: normal;
  margin: 24px 0 24px 24px;
`;
